import { EMPTY_OBJECT } from '../../../../../constants/common'
import i18n from '../../../../../i18n'

import {
  API_KEY_ALL,
  CONTACT_STATISTIC_ITEMS,
  ITEM_TRANSLATION_KEY_NAME,
  ROLE_STATISTIC_ITEMS,
  STATUS_STATISTIC_ITEMS,
  SUMMARY_STATISTIC_ITEMS,
} from './useStatisticData.constants'

function parseByTabData(data, items) {
  return items.map(i => {
    return { name: i18n.t(ITEM_TRANSLATION_KEY_NAME[i]), value: data[i] }
  })
}

export function parseStatisticData(data) {
  if (!data) {
    return EMPTY_OBJECT
  }

  const summaryData = parseByTabData(data, SUMMARY_STATISTIC_ITEMS)
  const roleData = parseByTabData(data, ROLE_STATISTIC_ITEMS)
  const statusData = parseByTabData(data, STATUS_STATISTIC_ITEMS)
  const contactData = parseByTabData(data, CONTACT_STATISTIC_ITEMS)
  const allCount = data[API_KEY_ALL]

  return { allCount, contactData, roleData, statusData, summaryData }
}
